import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import { translationsSelector } from '../../../selectors/translations';
import { CustomIcon, Link, ThemeButton } from '../../common';

const contacts = translations => [
  {
    label: 'TROY_PHONE',
    icon: 'contactTel',
    link: `tel:${translations['TROY_PHONE']}`,
    id: 'page.component.home-container.contact-phone'
  },
  {
    label: 'Whatsapp',
    icon: 'contactWhatsapp',
    link: `https://wa.me/${translations['TROY_WHATSAPP']}`,
    id: 'page.component.home-container.contact-whatsapp'
  },
  {
    label: 'SMS',
    icon: 'contactChat',
    link: `sms:${translations['TROY_SMS']}`,
    id: 'page.component.home-container.contact-chat'
  },
  {
    label: 'E-Mail',
    icon: 'contactMail',
    link: `mailto:${translations['TROY_EMAIL']}`,
    id: 'page.component.home-container.contact-email'
  },
  {
    label: 'Twitter',
    icon: 'contactTwitter',
    link: translations['TROY_TWITTER'],
    id: 'page.component.home-container.contact-twitter'
  }
];

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.secondary.contrastText
  },
  link: {
    marginLeft: 16,
    '&:first-of-type': {
      marginLeft: 0
    }
  }
}));

const ContactsBarContent = ({ className }) => {
  const classes = useStyles();
  const translations = useSelector(translationsSelector);
  const items = contacts(translations);

  return (
    <Box className={classNames(classes.wrapper, className)}>
      {items.map(({ label, icon, link, id }) => (
        <ThemeButton
          key={id}
          id={id}
          className={classes.link}
          size="medium"
          color="secondary"
          fontStyle="subtitle1"
          startElement={
            <CustomIcon icon={icon} variant="secondary" size="small" />
          }
          component={React.forwardRef((props, ref) => (
            <Link raw to={link} target="_blank" {...props} ref={ref} />
          ))}
          textKey={label}
        />
      ))}
    </Box>
  );
};

export default ContactsBarContent;
